import {t} from '@lingui/core/macro';

export function getDomainBatchModalHeader(actionValue?: string): string {
    switch (actionValue) {
        case 'start':
            return t`Массовое включение мониторов доменов`;
        case 'stop':
            return t`Массовая остановка мониторов доменов`;
        case 'edit':
            return t`Массовое изменение мониторов доменов`;
        case 'delete':
            return t`Массовое удаление мониторов доменов`;
        case 'tags':
            return t`Массовое добавление тегов`;
        case 'export':
            return t`Экспорт выбранных мониторов доменов`;
        case 'remove-by-url':
            return t`Удаление мониторов по списку доменов`;
        default:
            return t`Массовые операции`;
    }
}
